import { getRootElement } from "@phn/utility/helper";
import { motionDurationShort } from "@porsche-design-system/components-js/styles";
import animationManager, {
  AnimationEndsCallbacks,
  makeSequence,
} from "../../../../services/animation-manager";
import { AnimationSequences } from "@phn/utility/constants";

const firstDrawer = "phn-nd-single-drawer .drawer:not(.animating)";
const animationDrawer = "phn-nd-single-drawer .drawer.animating";

export default function registerTransitionPreviousLevelSingleDrawerAnimation({
  onAnimationEnds,
}: AnimationEndsCallbacks): void {
  animationManager.register(
    AnimationSequences.TRANSITION_PREVIOUS_LEVEL_SINGLE_DRAWER,
    makeSequence([
      [
        {
          onStart: () => {
            const elem = getRootElement().querySelector(firstDrawer);
            if (elem) (elem as HTMLElement).style.opacity = "0";
          },
          elementSelector: animationDrawer,
          animation: {
            className: "translate-backward-animation-out",
          },
          onEnd: () => {
            // Stay hidden after animation
            const elem = getRootElement().querySelector(animationDrawer);
            if (elem) (elem as HTMLElement).style.opacity = "0";
          },
        },
        {
          onStart: async () => {
            await new Promise((resolve) => {
              setTimeout(
                resolve,
                Number(motionDurationShort.replace("s", "")) * 1000,
              );
            });
          },
          elementSelector: firstDrawer,
          animation: {
            className: "translate-backward-animation-in",
          },
          onEnd: () => {
            const elem = getRootElement().querySelector(firstDrawer);
            if (elem) (elem as HTMLElement).style.opacity = "1";
            onAnimationEnds();
          },
        },
      ],
    ]),
  );
}
